module.exports = __webpack_public_path__ + "img/slider-3.818fd358.jpg";